<template>
  <div>
    <el-button type="primary" @click="dialogVisible = true"
      >新建月化结算</el-button
    >
    <el-dialog
      :visible="dialogVisible"
      title="新建结算"
      width="1000px"
      @close="closeDialog"
      @open="onOpen"
    >
      <el-form :model="detail" label-width="160px">
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <el-form-item label="最大小数位">{{detail.precision}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最小锁仓数">{{detail.minAmount}}</el-form-item>
          </el-col>-->
          <!-- <el-col :span="8">
            <el-form-item label="结算最小有效小时数">{{detail.unitHour}}</el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="18">
          <el-col :span="6">
            <el-form-item label="结算最小有效小时数">{{
              detail.unitHour
            }}</el-form-item>
          </el-col>
          <!-- <el-col :span="6">
            <el-form-item label="年利率">
              <span v-if="detail.annualizedRate">{{ math.multiply(detail.annualizedRate ,100)}} %</span>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="6">
            <el-form-item label="锁仓分红占收益比例">
              <span v-if="detail.bonusRate">{{math.multiply(detail.bonusRate, 100)}} %</span>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="8">
            <el-form-item label="推荐人奖励比例">
              <span v-if="detail.inviteProfitRate">{{math.multiply(detail.inviteProfitRate, 100)}} %</span>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="8">
            <el-form-item label="掌门奖励比例">
              <span v-if="detail.ownerProfitRate">{{math.multiply(detail.ownerProfitRate, 100)}} %</span>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="掌门人排行分红比例">
              <span
                v-if="detail.bonusRate"
              >{{detail.rankingRates && detail.rankingRates.split(',').map(item => math.multiply(item, 100) + ' %').join(' | ')}}</span>
            </el-form-item>
          </el-col>-->
        </el-row>
      </el-form>
      <el-form
        :model="submitData"
        label-width="160px"
        ref="form"
        :rules="rules"
      >
        <el-form-item prop="leagueId" label="结算门派">
          <el-select v-model="submitData.leagueId" placeholder="请选择">
            <el-option
              v-for="item in list"
              :key="item.id"
              :label="item.name && item.name.zh"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="annualizedRate" label="月化率">
          <el-input type="number" v-model="submitData.annualizedRate">
            <span slot="append" v-if="submitData.annualizedRate"
              >{{ math.multiply(submitData.annualizedRate, 100) }} %</span
            >
          </el-input>
        </el-form-item>
        <el-form-item prop="startTime" label="结算时间范围">
          <el-row :gutter="20">
            <el-col :span="7">
              <el-date-picker
                v-model="submitData.startTime"
                value-format="timestamp"
                type="datetime"
                placeholder="结算开始时间"
              ></el-date-picker>
            </el-col>
            <el-col :span="7">
              <el-date-picker
                v-model="submitData.endTime"
                value-format="timestamp"
                type="datetime"
                placeholder="结算截止时间"
              ></el-date-picker>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
import math from 'common/math';

export default {
  name: 'leagueCreate',
  data() {
    return {
      dialogVisible: false,
      detail: {},
      rules: {
        leagueId: { required: true, message: '请填写' },
        annualizedRate: { required: true, message: '请填写' },
        startTime: { required: true, message: '请填写' },
        endTime: { required: true, message: '请填写' }
      },
      submitData: {
        //   leagueId: undefined,
        // annualizedRate: undefined,
        // startTime: undefined,
        // endTime: undefined,
      },

      math
    };
  },
  components: {
    Editor,
    Upload
  },
  computed: {
    ...mapState('league', ['list'])
  },
  methods: {
    ...mapActions('leagueSettle', ['createSettle']),
    ...mapActions('league', ['getConfig', 'getList']),
    closeDialog() {
      this.dialogVisible = false;
      // this.detail = {};
      this.submitData = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    onOpen() {
      this.getData();
    },
    getData() {
      this.getConfig().then(res => {
        this.detail =
          (res.data && {
            ...res.data,
            rankingRates: res.data.rankingRates.join(',')
          }) ||
          {};
      });
      this.getList();
    },
    doSave() {
      this.createSettle({
        leagueId: this.submitData.leagueId,
        annualizedRate: this.submitData.annualizedRate,
        startTime: this.submitData.startTime,
        endTime: this.submitData.endTime,
        type: 0
      }).then(() => {
        this.$message({
          message: '添加成功！',
          type: 'success'
        });
        this.dialogVisible = false;
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  },
  mounted() {
    if (this.$route.query.leagueId) {
      this.submitData.leagueId = this.$route.query.leagueId;
      this.dialogVisible = true;
      this.$router.replace(this.$route.path);
    }
  }
};
</script>

<style lang="less">
.editor {
  height: 500px;
}
</style>
